module.exports = __webpack_public_path__ + "img/shinkanote_logo.ab661f82.svg";